import React from 'react';
import './StatisticsPanel.css';

function StatisticsPanel({ data, theme, themeColors }) {
  if (!data) {
    return <div className="placeholder">Network statistics will appear here.</div>;
  }
  
  return (
    <div className="statistics-panel">
      <h3>Network Statistics</h3>
      
      <div className="stat-group">
        <div className="stat-item">
          <div className="stat-label">Proposals</div>
          <div className="stat-value">{data.Proposals || 0}</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-label">Nodes</div>
          <div className="stat-value">{data.Nodes || 0}</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-label">Edges</div>
          <div className="stat-value">{data.Edges || 0}</div>
        </div>
      </div>
      
      {/* Commented out network metrics - can be re-enabled if needed */}
      {/* <div className="stat-group">
        <div className="stat-item">
          <div className="stat-label">Avg. Degree</div>
          <div className="stat-value">{(data['Average degree'] || 0).toFixed(2)}</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-label">Density</div>
          <div className="stat-value">{(data.Density || 0).toFixed(3)}</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-label">Modularity</div>
          <div className="stat-value">{(data.Modularity || 0).toFixed(3)}</div>
        </div>
      </div> */}
      
      {/* Commented out betweenness centrality - can be re-enabled if needed */}
      {/* data['Top 5 nodes by betweenness centrality'] && (
        <div className="key-nodes">
          <h4>Key nodes by betweenness centrality:</h4>
          <ul>
            {data['Top 5 nodes by betweenness centrality'].map((item, index) => (
              <li key={index}>{item[0]}: {item[1]}</li>
            ))}
          </ul>
        </div>
      ) */}
    </div>
  );
}

export default StatisticsPanel;